import styled from 'styled-components';
import { PlainButtonBar, PrimaryButton, SecondaryButton } from './Button';
import { Spacer } from '../editor/EditorHelpers';

export interface ConfirmDialogProps {
  isOpen: boolean;
  onConfirm?: () => void;
  onCancel: () => void;
  message: string;
  title: string;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ 
  isOpen, onConfirm, onCancel, message, title
}) => {
  if (!isOpen) return null;

  return (
    <DialogOverlay>
      <DialogContent>
        <DialogHeader>{title}</DialogHeader>
        <DialogMessage>{message}</DialogMessage>
        <PlainButtonBar>
          <Spacer style={{flexGrow: 1}} />
          <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
          <PrimaryButton onClick={onConfirm}>Confirm</PrimaryButton>
          <Spacer style={{flexGrow: 1}} />
        </PlainButtonBar>
      </DialogContent>
    </DialogOverlay>
  );
};

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(32, 32, 32, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DialogContent = styled.div`
  background: var(--bg-color);
  padding: 2rem;
  max-width: 350px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  text-align: center;
`;

const DialogHeader = styled.h2`
  margin: 0.5rem 0 0 0;
`;

const DialogMessage = styled.p`
  margin-top: 2rem;
  margin-bottom: 2rem;
`;


